import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { settingsSelectors, UserType } from '@wam/shared';

@Injectable()
export class WaterfordHeadersInterceptor implements HttpInterceptor {
  private readonly store = inject(Store);

  private userType = UserType.UNKNOWN;
  private version: string = 'unknown';

  constructor() {
    this.store.pipe(select(settingsSelectors.getUserType)).subscribe((userType) => {
      this.userType = userType;
    });

    this.store.pipe(select(settingsSelectors.getVersion)).subscribe((version) => {
      this.version = version;
    });
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const cloned = req.clone({
      setHeaders: {
        'X-Waterford-Client-ID': this.userType,
        'X-Waterford-Client-Version': this.version,
      },
    });
    return next.handle(cloned);
  }
}
